import {
  FaGithub,
  FaInstagram,
  FaLinkedinIn,
  FaFacebook,
  FaEnvelope,
  FaLink,
  FaGlobe,
  FaYoutube,
  FaXTwitter
} from 'react-icons/fa6'

export default {
  default: {
    Icon: FaLink,
    color: '#718096'
  },
  youtube: {
    Icon: FaYoutube,
    color: '#FF0000'
  },
  github: {
    Icon: FaGithub,
    color: 'darkslategray'
  },
  twitter: {
    Icon: FaXTwitter,
    color: '#000'
  },
  instagram: {
    Icon: FaInstagram,
    color: '#C13584'
  },
  linkedin: {
    Icon: FaLinkedinIn,
    color: '#2867B2'
  },
  facebook: {
    Icon: FaFacebook,
    color: '#4267B2'
  },
  email: {
    Icon: FaEnvelope,
    color: '#718096'
  },
  website: {
    Icon: FaGlobe,
    color: 'darkslategray'
  }
}
